export default __webpack_public_path__ + "static/media/apple_app_link.54619a42.png";